export enum buildingType {
    singleLoadedCorridor = 'singleLoadedCorridor',
    doubleLoadedCorridor = 'doubleLoadedCorridor',
    rowhouse = 'rowhouse',
    tower = 'tower',
    hybrid = 'hybrid'
}